import { Controller } from "@hotwired/stimulus";

// Shows the email exactly as the customer will receive it, beside the form that
// writes it. The server renders the real email (same mailer and layout), so
// what is shown here is what is sent. It also sends a test to the owner and
// switches to a view of the document the customer will open.
export default class extends Controller {
	static targets = [
		"form",
		"emailFrame",
		"documentFrame",
		"subject",
		"notice",
		"status",
		"emailTab",
		"documentTab",
		"emailPanel",
		"documentPanel",
	];
	static values = { previewUrl: String, testUrl: String, documentUrl: String };

	connect() {
		this.refresh();
	}

	disconnect() {
		clearTimeout(this.timer);
	}

	// Called on every keystroke; waits for a pause before asking the server
	schedule() {
		clearTimeout(this.timer);
		this.timer = setTimeout(() => this.refresh(), 500);
	}

	async refresh() {
		const response = await this.post(this.previewUrlValue);
		if (!response.ok) return;

		const data = await response.json();
		this.subjectTarget.textContent = data.subject || "";

		if (data.error) {
			this.showNotice(data.error);
			return;
		}

		this.hideNotice();
		this.emailFrameTarget.srcdoc = data.html;
	}

	async sendTest(event) {
		event.preventDefault();
		this.status("Sending a test to you...", false);

		const response = await this.post(this.testUrlValue);
		const data = await response.json();

		this.status(data.message || data.error, !response.ok);
	}

	showEmail() {
		this.toggle("email");
	}

	showDocument() {
		if (!this.documentFrameTarget.getAttribute("src")) {
			this.documentFrameTarget.setAttribute("src", this.documentUrlValue);
		}
		this.toggle("document");
	}

	toggle(which) {
		const email = which === "email";
		this.emailPanelTarget.hidden = !email;
		this.documentPanelTarget.hidden = email;
		this.emailTabTarget.setAttribute("aria-selected", email);
		this.documentTabTarget.setAttribute("aria-selected", !email);
	}

	post(url) {
		return fetch(url, {
			method: "POST",
			body: new FormData(this.formTarget),
			headers: {
				Accept: "application/json",
				"X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content,
			},
			credentials: "same-origin",
		});
	}

	showNotice(message) {
		this.noticeTarget.textContent = message;
		this.noticeTarget.hidden = false;
	}

	hideNotice() {
		this.noticeTarget.hidden = true;
	}

	status(message, isError) {
		this.statusTarget.textContent = message;
		this.statusTarget.classList.toggle("text-danger-600", isError);
		this.statusTarget.classList.toggle("text-ink-600", !isError);
	}
}
